export default {
  title: {
    id: 'merchant_home_page_title',
    defaultMessage: 'Hello, { merchantName }!',
  },
  pageTitle: {
    id: 'bo_seller-homepage-page_title',
    defaultMessage: 'Home',
  },
}
